import { apiRequest } from "./api";
import type { LedgerEvent } from "./ledgerApi";

export interface FinancialCategoryTotal {
  total: number;
  count: number;
}

export interface FinancialSummary {
  period: { from: string; to: string };
  revenue: {
    serviceRecords: FinancialCategoryTotal;
    storeIncome: FinancialCategoryTotal;
    serviceRequests: FinancialCategoryTotal;
    manualIncome: FinancialCategoryTotal;
    grossRevenue: number;
  };
  costs: {
    payroll: FinancialCategoryTotal;
    storeExpenses: FinancialCategoryTotal;
    manualExpenses: FinancialCategoryTotal;
    loanDisbursements: FinancialCategoryTotal;
    cashAdvances: FinancialCategoryTotal;
    walletEncashments: FinancialCategoryTotal;
    walletAdvances: FinancialCategoryTotal;
    totalOperating: number;
    totalDisbursements: number;
    grandTotal: number;
  };
  recoveries: {
    loanRepayments: FinancialCategoryTotal;
    cashAdvanceRepayments: FinancialCategoryTotal;
    walletAdvanceRepayments: FinancialCategoryTotal;
    total: number;
  };
  grossProfit: number;
  netPosition: number;
  trend: { label: string; revenue: number; expenses: number; net: number }[];
}

export interface FinancialTransactionsResult {
  items: LedgerEvent[];
  total: number;
  nextOffset?: number;
}

export const financialsApi = {
  getSummary: (businessId: string, from: string, to: string): Promise<FinancialSummary> =>
    apiRequest<FinancialSummary>(`/biz/${businessId}/financials?from=${from}&to=${to}`),

  getAllSummary: (from: string, to: string): Promise<FinancialSummary> =>
    apiRequest<FinancialSummary>(`/admin/financials/summary?from=${from}&to=${to}`),

  getTransactions: (
    businessId: string,
    from: string,
    to: string,
    category: string,
    offset = 0,
  ): Promise<FinancialTransactionsResult> =>
    apiRequest<FinancialTransactionsResult>(
      `/biz/${businessId}/financials/transactions?from=${from}&to=${to}&category=${category}&offset=${offset}`,
    ),
};
